<template>
  <component :is="isSelected" @switchPanel="switchP($event)">

  </component>


</template>

<script>
  import DonationList from "@/pages/List/MyDonationList.vue"
  import MyDonationForm from "@/pages/List/MyDonation/MyDonationForm.vue"

  export default {
    components: {
      MyDonationList: DonationList,
      MyDonationForm: MyDonationForm
    },

    data() {
      return {
        isSelected: 'MyDonationList'
      }
    },
    methods:{
      switchP(e){
        console.log("asdasd",e)
        this.isSelected=e
      }
    }

  }

</script>
